import { Box } from '@mui/material';
import { type FleetDeviceDetailsPerDay } from 'types/fuelAnalytics';
import useAppTheme from 'hooks/useAppTheme';
import FuelAssetItemChart from './FuelAssetItemChart';
import FuelAssetHeader from './FuelAssetHeader';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const FuelAssetItem = ({
  data,
  selectedSource,
  aggregation,
  getSourceLabel,
}: {
  data: FleetDeviceDetailsPerDay;
  selectedSource: string[];
  aggregation: string;
  getSourceLabel?: (source: string) => string;
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Box
      sx={{
        height: '350px',
        backgroundColor:
          CLIENT_THEME === 'yokohama'
            ? palette.paperBackground
            : enableDarkTheme
            ? '#19304F'
            : palette.toolBarBackground,
        marginBottom: '15px',
        padding: '10px',
        borderRadius: '4px',
        border: `1px solid ${palette.cardBorderColor}`,
      }}
      data-attribute="assetItemBox"
    >
      {/* Header Section */}
      <FuelAssetHeader data={data} />

      {/* Bar Chart Section */}
      <FuelAssetItemChart
        data={data}
        selectedSource={selectedSource}
        aggregation={aggregation}
        getSourceLabel={getSourceLabel}
      />
    </Box>
  );
};

export default FuelAssetItem;
